import { configurationConstants } from "../actions/types";
const initialState = {
    userConfiguration: {},
    userConfiguration2: {},
    primaryBarSelection: null,
    selectionStatus: { System: true },
    disabledFeatures: [],
    disabledOptions: [],
};
function clearDisabledKeys(configuration, disabledFeatures) {
    const newConfiguration = Object.assign({}, configuration);
    disabledFeatures.forEach((feature) => {
        if (Object.prototype.hasOwnProperty.call(newConfiguration, feature)) {
            newConfiguration[feature] = ""; // or delete newConfiguration[feature];
        }
    });
    return newConfiguration;
}
export const configurationReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case configurationConstants.SET_CONFIGURATION:
            return Object.assign(Object.assign({}, state), { userConfiguration: payload });
        case configurationConstants.UPDATE_CONFIGURATION2: {
            const mergedConfig = Object.assign(Object.assign({}, state.userConfiguration2), payload);
            const newUserConfiguration2 = clearDisabledKeys(mergedConfig, state.disabledFeatures);
            return Object.assign(Object.assign({}, state), { userConfiguration2: newUserConfiguration2 });
        }
        case configurationConstants.DELETE_PROPERTY:
            return Object.assign(Object.assign({}, state), { userConfiguration2: Object.assign(Object.assign({}, state.userConfiguration2), { [payload]: undefined }) });
        case configurationConstants.RESET_CONFIGURATION:
            return Object.assign(Object.assign({}, state), { userConfiguration2: {} });
        case configurationConstants.UPDATE_SELECTION_STATUS:
            return Object.assign(Object.assign({}, state), { selectionStatus: Object.assign(Object.assign({}, state.selectionStatus), payload) });
        case configurationConstants.SET_PRIMARY_BAR_SELECTION:
            return Object.assign(Object.assign({}, state), { primaryBarSelection: payload });
        case configurationConstants.DISABLE_FEATURES:
            const newArr = [...state.disabledFeatures];
            payload.forEach((element) => {
                if (!newArr.includes(element)) {
                    newArr.push(element);
                }
            });
            return Object.assign(Object.assign({}, state), { disabledFeatures: newArr });
        case configurationConstants.ENABLE_FEATURES:
            return Object.assign(Object.assign({}, state), { disabledFeatures: state.disabledFeatures.filter((item) => !payload.includes(item)) });
        case configurationConstants.DISABLE_OPTIONS:
            const newArr2 = [...state.disabledOptions];
            payload.forEach((element) => {
                if (!newArr2.includes(element)) {
                    newArr2.push(element);
                }
            });
            return Object.assign(Object.assign({}, state), { disabledOptions: newArr2 });
        case configurationConstants.ENABLE_OPTIONS:
            return Object.assign(Object.assign({}, state), { disabledOptions: state.disabledOptions.filter((item) => !payload.includes(item)) });
        default:
            return state;
    }
};
